/*
 * File: ConfettiBurst.styles.js
 * Project: seesaw-marketplace-app
 *
 * Created by Brendan Michaelsen on February 7, 2022 at 1:53 PM
 * Copyright © 2022 Seesaw Technologies, LLC. All rights reserved.
 *
 * Last Modified: January 22, 2023 at 3:35 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';


/**
 * Styles
 */

export const ConfettiContainer = styled.div`
	overflow: hidden;
	width: 100%;
	height: 100%;
	position: fixed;
	left: 0px;
	top: 0px;
	pointer-events: none !important;

	&.confettiContainer {
		pointer-events: none !important;
	}
`;

export const ConfettiPoint = styled.div`
	position: relative;
	top: ${({ $y }) => $y}px;
	left: ${({ $x }) => $x}px;
`;
